<!--
    课程分享-课时编辑-课时分类
    作用：课时分类组件
    功能：课时分类数据，编辑/新增课时分类
    说明：版本3.0
-->
<template>
  <el-dialog
    title="移动"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    width="450px"
  >
    <el-form ref="dataForm" :model="form" :rules="rules">
        <el-form-item label="课时分类" prop="cascaderVal" label-width="110px">
        <el-cascader
          v-model="form.cascaderVal"
          :options="treeData"
          :props="{
            value: 'id',
            label: 'name',
            checkStrictly: true,
            children: 'recursive_children',
          }"
          clearable
        ></el-cascader>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitData" :loading="submitLoading">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { movePacketHours } from '@/api/courseOn'
export default {
  name: 'typeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    },
    selClass: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      submitLoading: false,
      form: {
        cascaderVal: []
      },
      rules: {
        cascaderVal: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('close-dialog')
    },
    submitData () {
      // const selectSchoolId = this.$store.state.choicesSchool.id
      // const packet_id = this.$route.query.packetId
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const packet_id = this.$route.query.packetId
          const detail_category_id = this.form.cascaderVal[this.form.cascaderVal.length - 1]
          const detail_list = []
          this.selClass.forEach(item => {
            detail_list.push({
              detail_id: item
            })
          })
          const obj = {
            packet_id,
            detail_category_id,
            detail_list
          }
          this.submitLoading = true
          movePacketHours(this.$store.state.choicesSchool.id, obj).then(res => {
            if (res.status_code === 200) {
              this.$message.success('操作成功！')
              this.$emit('refresh')
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => {
            this.$emit('close-dialog')
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/components/typeDialog.vue